import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75002 9.1109L13.6667 4.32328L13.6667 0.833577L7.00002 7.36401L0.333354 0.833576L0.333354 4.30695L5.20835 9.1109L5.50835 9.40477C5.89887 9.78611 6.42778 10.0002 6.97919 10.0002C7.53059 10.0002 8.05951 9.78611 8.45002 9.40477L8.75002 9.1109Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
